import React, { Component } from "react";
import {
  Grid,
  Icon,
  Button,
  Divider,
  Dropdown,
  Label,
  Form
} from "semantic-ui-react";
import { app } from "../../index";
import "./custinfo.css";
// import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
// import { log } from "util";
import { createservice } from "../../services/crudservice";
class CompanyInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      editing: false,
      editvalue: {},
      deletevalue: [],
      deletelist: [],
      editinfo: {},
      formtitle: "Edit:",
      newitem: false,
      nexttm: null,
      nextinv: null,
      nextwod: null,
      newentry: true
    };
  }
  // componentDidUpdate(prevProps, prevState) {
  //   if (this.props.companyitems !== undefined && this.state.list.length === 0) {
  //     this.gencompanys();
  //   }
  // }
  componentDidMount() {
    if (this.props.companyitems && this.state.list.length === 0) {
      console.log(this.props.companyitems);
      this.gencompanys();
    }
  }
  getnextstuff(custnumber) {
    console.log("getting next stuff");
    app
      .service("tminvparams")
      .get(custnumber)
      .then(response => {
        this.setState({
          nexttm: response.nexttmnumber,
          nextinv: response.nextinvnumber,
          nextwod: response.nextwonumber
        });
      })
      .catch(error => {
        if (error.code === 404) {
          this.setState({ nexttm: "N/A", nextinv: "N/A", nextwod: "N/A" });
        }
      });
  }
  gencompanys() {
    let lst = this.state.list;
    this.props.companyitems.map(item => {
      let itemtext = item.custname + " - " + item.contactname;
      let newitem = {
        key: item.custnumber,
        value: item,
        text: itemtext
      };
      var custnumbers = this.props.companyitems.map(cust => cust.custnumber);
      lst.push(newitem);
      this.setState({ list: lst, custnumbers });
    });
  }
  gencustnumInput() {
    if (this.state.newentry) {
      this.state.editvalue.custnumber;

      return (
        <Form.Input
          value={this.state.editvalue.custnumber}
          error={
            this.state.custnumbers.includes(this.state.editvalue.custnumber) ||
            !parseInt(this.state.editvalue.custnumber)
          }
          label="Customer Number:"
          onKeyPress={e => {
            console.log(e.key);
            if (!parseInt(e.key) && e.key != 0) {
              e.preventDefault();
            }
          }}
          onChange={e => {
            this.setState({
              editvalue: {
                ...this.state.editvalue,
                custnumber: parseInt(e.target.value)
                  ? parseInt(e.target.value)
                  : e.target.value
              }
            });
          }}
        />
      );
    } else {
      return (
        <Label size="large">
          Customer Number: {"  " + this.state.editvalue.custnumber}
        </Label>
      );
    }
  }
  handlesave() {
    if (this.state.newentry) {
      createservice("customers", this.state.editvalue).then(res => {
        this.setState({ newentry: false });
      });
    } else {
      this.props.handleupdateitems(
        this.state.editvalue,
        this.state.editvalue.custnumber,
        "customers"
      );
    }
  }
  handledelete() {
    var deletepayload = [];
    this.state.deletevalue.map(dl => {
      let newtitle =
        dl.custnumber + " - " + dl.custname + " - " + dl.contactname;
      let newitem = {
        title: newtitle,
        id: dl.id
      };
      deletepayload.push(newitem);
    });
    console.log(deletepayload);
    this.props.handleDelete(deletepayload, "company");
  }
  getnewCompany() {
    if (this.props.companyitems && this.props.companyitems.length) {
      let newCustNumber =
        Math.max.apply(Math, this.props.companyitems.map(c => c.custnumber)) +
        1;
      return {
        custnumber: newCustNumber,
        custname: "",
        contactemail: "",
        contactname: ""
      };
    }
  }
  geneditform() {
    let nexttm = this.state.nexttm;
    let nextinv = this.state.nextinv;
    let nextwod = this.state.nextwod;
    let company = Object.assign({}, this.state.editvalue);
    if (company.lastcontactdate) {
      company.lastcontactdate = moment(company.lastcontactdate);
    }
    if (company.nextcontactdate) {
      company.nextcontactdate = moment(company.nextcontactdate);
    }
    // if (
    //   this.state.editvalue.nextcontactdate !== company.nextcontactdate ||
    //   this.state.editvalue.lastcontactdate !== company.lastcontactdate
    // ) {
    //   this.setState({ editvalue: company });
    // }

    if (this.state.editing !== false) {
      return (
        <div>
          <Grid>
            <Grid.Column width={2}>
              <h3>{this.state.formtitle}</h3>
            </Grid.Column>
            <Grid.Column width={3}>
              <h4>{company.custname}</h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <h4>{company.contactname}</h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <Button
                id="billingsavebtn"
                color={this.state.newentry ? "blue" : "green"}
                onClick={() => this.handlesave()}
              >
                {this.state.newentry ? "Create Company" : "Save"}
              </Button>
              <Button
                id="billingsavebtn"
                onClick={() => this.setState({ editing: false })}
              >
                Cancel
              </Button>
            </Grid.Column>
          </Grid>
          <Divider />
          <Form>
            <Grid>
              <Grid.Column width={2} textAlign="center">
                <Form.Field>{this.gencustnumInput()}</Form.Field>
              </Grid.Column>
              <Grid.Column width={8}>
                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Company Name"
                    value={company.custname}
                    onChange={e => {
                      company.custname = e.target.value;
                      this.setState({ editvalue: company });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Contact Name"
                    value={company.contactname}
                    onChange={e => {
                      company.contactname = e.target.value;
                      this.setState({ editvalue: company });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Contact Email"
                    value={company.contactemail}
                    onChange={e => {
                      company.contactemail = e.target.value;
                      this.setState({ editvalue: company });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input width={3} label="Next TM Number" value={nexttm} />
                  <Form.Input
                    width={4}
                    label="Next Invoice Number"
                    value={nextinv}
                  />
                  <Form.Input
                    width={5}
                    label="Next Work Order Number"
                    value={nextwod}
                  />
                </Form.Group>
              </Grid.Column>
            </Grid>
          </Form>
        </div>
      );
    }
  }

  render() {
    var newcompany = this.getnewCompany();
    return (
      <div className="CompanyInfo">
        <Grid>
          <Grid.Column width={5}>
            <Label>Select Company to Edit</Label>

            <Dropdown
              placeholder="Company"
              fluid
              search
              selection
              value={this.state.newentry ? null : this.state.editvalue}
              options={this.state.list}
              onChange={(e, { value }) => {
                this.getnextstuff(value.custnumber);
                this.setState({
                  newentry: false,
                  editvalue: value,
                  editing: true,
                  formtitle: "Edit:"
                });
              }}
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <Button
              color="blue"
              id="deletecontactbutton"
              onClick={() =>
                this.setState({
                  newentry: true,
                  editing: true,
                  editvalue: newcompany,
                  nextwod: "TBD",
                  nexttm: "TBD",
                  nextinv: "TBD",
                  formtitle: "Add Company"
                })
              }
            >
              <Icon name="plus" /> Company
            </Button>
          </Grid.Column>
          <Grid.Column width={6}>
            <Label>Select Companies to Delete</Label>
            <Dropdown
              placeholder="Select Company to Delete"
              fluid
              search
              selection
              multiple
              options={this.state.list}
              onChange={(e, { value }) => {
                this.setState({ deletevalue: value });
              }}
            />
          </Grid.Column>
          <Grid.Column width={1}>
            <Button
              negative
              id="deletecontactbutton"
              onClick={() => this.handledelete()}
            >
              Delete
            </Button>
          </Grid.Column>
        </Grid>
        <Divider />

        {this.geneditform()}
      </div>
    );
  }
}
export default CompanyInfo;



// WEBPACK FOOTER //
// ./src/components/customerinfo/company.js